<template>
  <div class="share-list-view">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'shareListView',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.share-list-view
  width 100%
  min-height 100%
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ShareListView.vue